import React from "react";
import CookieSettingsLink from "./CookieSettingsLink";
import { useSelector } from "react-redux";
import { get } from "lodash";
import PrismicRichText from "../PrismicRichText";
import AccessibilitySwitch from "../AccessibilitySwitch";
import Link from "../Link";
import { useLocation } from "react-router-dom";

export default function Footer() {
  const location = useLocation();
  const componentLoading = useSelector((state) =>
    get(state, "prismic.site_settings.loading", true)
  );
  const component = useSelector((state) =>
    get(state, "prismic.site_settings.data", false)
  );

  const backgroundColor = get(component, "footer_background_color");
  const textColor = get(component, "footer_text_color");

  const backgroundStyle = {
    color: textColor,
    background: backgroundColor,
  };

  const labResultsPage = location.pathname === "/hemp";
  const brand = labResultsPage ? "Altus LLC" : "Good News";

  const year = new Date().getFullYear();

  const linkResolver = (doc) => {
    return `/${doc.uid}`;
  };

  const renderFooterColumns = (columns) => {
    return columns.map((el, i) => (
      <div key={i} className="footer-section">
        <div className="heading">
          <PrismicRichText
            linkResolver={linkResolver}
            render={el.column_title}
          />
        </div>
        <div className="content">
          <PrismicRichText linkResolver={linkResolver} render={el.content} />
        </div>
      </div>
    ));
  };

  const renderSocialLinks = (socialLinks) => {
    return socialLinks.map((el, i) => (
      <Link
        key={i}
        url={get(el, "link.url")}
        target="_blank"
        rel="noopener noreferrer"
      >
        <img src={get(el, "icon.url")} alt="Social Icon"></img>
      </Link>
    ));
  };

  return (
    !componentLoading &&
    component && (
      <footer className="standard-padding">
        <div className="wrapper footer-wrapper">
          <div className="footer-section">
            <p>
              {labResultsPage ? (
                <span className="logo-text">ALTUS LLC</span>
              ) : (
                <>
                  <span className="mr-10">Grown by </span>
                  <span className="logo-text">CRESCO LABS</span>
                </>
              )}
            </p>
            {!labResultsPage && (
              <p>
                We’re on a mission to normalize, professionalize, and
                revolutionize cannabis.
              </p>
            )}
          </div>
          {renderFooterColumns(component.footer)}
          <div className="footer-section">
            <div className="cookie-settings mb-10">
              <CookieSettingsLink />
            </div>
            <div className="social">
              <p className="copyright">
                ©{year} {brand}. All rights reserved.
              </p>
              {renderSocialLinks(component.social_links)}
              <div className="accessibility">
                <AccessibilitySwitch />
              </div>
            </div>
          </div>
        </div>
      </footer>
    )
  );
}
